import { useEffect, useMemo, useState } from "react";
import { usePermissions } from "./usePermissions";
import { localTodayISO } from "../helpers/planning/planningModel";
import { loadCommandTasks } from "../helpers/dashboard/commandDashboardData";
import {
  buildProjectTaskStats,
  projectIdsWithOverdueTasks,
} from "../helpers/dashboard/commandDashboardModel";

/**
 * Real per-project task counts for the desktop Projects landing. Disabled
 * (no query) unless `enabled`; null result = tasks not available to this user.
 */
export function useProjectTaskStats({ enabled }) {
  const { actor } = usePermissions();
  const [raw, setRaw] = useState(null);
  const userKey = actor?.supabase_user_id || actor?.id || "";
  const today = useMemo(() => localTodayISO(new Date()), []);

  useEffect(() => {
    if (!enabled || !actor) {
      setRaw(null);
      return undefined;
    }
    let cancelled = false;
    Promise.resolve()
      .then(() => loadCommandTasks(actor))
      .then((result) => {
        if (!cancelled) setRaw(result);
      })
      .catch(() => {
        if (!cancelled) setRaw(null);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, userKey]);

  return useMemo(() => {
    if (!raw) return null;
    const input = { tasks: raw.tasks, projects: raw.projects, today };
    return {
      ...buildProjectTaskStats(input),
      overdueProjectIds: projectIdsWithOverdueTasks(input),
    };
  }, [raw, today]);
}
